<template>
  <div class="course">
    <div class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('navigation.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item>OpenDots 2 {{ $t('course.seriesPartsTutorial') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="go-back">
        <img @click="goBack" src="@/assets/icons/left.svg" alt="">
        <span @click="goBack">{{ $t('navigation.goBack') }}</span>
      </div>
      <div class="banner">
        <img class="pc-show" src="@/assets/images/course_bg_pc.webp" alt="">
        <img class="mb-show" src="@/assets/images/course_bg_mb.webp" alt="">
        <div class="banner_content">
          <h2>OpenDots 2  {{ $t('course.seriesPartsTutorial') }}</h2>
          <p>{{ $t('course.seriesPartsTutorialDesc1OpenDots2') }} {{ $t('course.seriesPartsTutorialDesc2OpenDots2') }}</p>
        </div>
      </div>
      <div class="section-2">
        <div class="title">
          {{ $t('course.selectDisplayStand') }}
        </div>
        <div class="content">
          {{ $t('course.clickDisplayStand') }}
        </div>
        <div class="tab-box">
          <div class="tab-title">OpenDots 2 {{$t('course.series')}}</div>
          <Tabs class="tab" :tabs="productList" v-model="activeName"></Tabs>
        </div>
        <div class="tab-content">
          <div class="title">
            <span>OpenDots 2 {{$t('course.series')}}</span>
            <i></i>
            <span>{{productInfo.title}}</span>
            <span>{{$t('course.partsTutorial')}}</span>
          </div>
          <video :src="videoUrl" controls ></video>
          <div class="tips">
           {{ $t('course.courseTipsDesc1OpenDots2') }} {{ $t('course.courseTipsDesc2OpenDots2') }}
          </div>
        </div>
      </div>
      <div class="explain-section">
        <div class="title">{{ $t('course.courseDesc') }}</div>
        <ul class="explain-list" :class="{'explain-list-en': lang === 'en'}">
          <li v-for="item in explainList" :key="item.text">
            <img :src="item.icon" alt="">
            <p>{{ $t(item.text) }}</p>
          </li>
        </ul>
        <div class="tips-box">
          <img src="@/assets/icons/InfoCircle.svg" alt="">
          <p>{{ $t('course.courseTips')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/Tabs.vue';
import { productListOpenDots2Cn, productListOpenDots2En } from '@/utils/util.js'
export default {
  components: {
    Tabs,
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    productInfo() {
      return (this.$i18n.locale === 'zh' ? productListOpenDots2Cn : productListOpenDots2En).find((item) => item.id === this.activeName) || {};
    },
    videoUrl() {
      const version = process.env.VUE_APP_VERSION || Date.now();
      return `/videos/openDots-replace/${this.lang}/${this.activeName}.mp4?v=${version}`;
    },
    productList() {
      const list = this.$i18n.locale === 'zh' ? productListOpenDots2Cn : productListOpenDots2En
      if (this.productType === '3.5') {
        return list.slice(0, 5)
      } else {
        return list
      }
    },
  },
  data() {
    return {
      activeName: '1',
      productId: this.$route.params.productId || (JSON.parse(localStorage.getItem('productVideoInfo')) || {}).productId,
      productType: this.$route.params.productType || (JSON.parse(localStorage.getItem('productVideoInfo')) || {}).productType,
      type: this.$route.params.type || (JSON.parse(localStorage.getItem('productVideoInfo')) || {}).type,
      explainList: [
        {
          text: 'course.courseDesc1',
          icon: require('@/assets/icons/Book.svg'),
        },
        {
          text: 'course.courseDesc2',
          icon: require('@/assets/icons/Tool.svg'),
        },
        {
          text: 'course.courseDesc3',
          icon: require('@/assets/icons/PlaySquare.svg'),
        },
        {
          text: 'course.courseDesc4',
          icon: require('@/assets/icons/Phone.svg'),
        },
      ]
    };
  },
  created() {
    if (!this.productId) {
      this.$router.push({ path: '/' });
    } else {
      this.activeName = this.productId
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/' });
    }
  }
}
</script>

<style lang='scss' scoped>
.course {
  padding-top: 32px;
  .banner {
    position: relative;
    margin-bottom: 48px;
    img {
      width: 100%;
    }
    .banner_content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      width: 100%;
      h2 {
        font-size: 40px;
        font-weight: 500;
        line-height: 110%;
        margin-bottom: 16px;
      }
      p {
        font-size: 20px;
        font-weight: 500;
        line-height: 120%;
      }
    }
  }
  .tab-box {
    display: flex;
    align-items: center;
    .tab-title {
      font-size: 20px;
      font-weight: 500;
      line-height: 120%;
      padding: 10px 0px;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      background: #FF7A3D;
      color: #fff;
      width: 200px;
      text-align: center;
    }
    .tab {
      width: calc(100% - 200px);
      ::v-deep .tabs-box {
          overflow: auto;
          .tab-item {
            flex: auto;
            width: auto;
            white-space: nowrap;
          }
       }
    }
  }
  .tab-content {
    margin-bottom: 66px;
    .title {
      margin-top: 32px;
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 500;
      line-height: 120%;
      color: #0A0A0A;
      i {
        display: inline-block;
        width: 1px;
        height: 18px;
        background: #000;
        margin: 0px 8px;
      }
      span:last-child {
        margin-left: 16px;
        display: inline-block;
      }
    }
    video {
      width: 100%;
    }
    .tips{
      color: #404040;
      font-size: 14px;
      line-height: 130%;
      padding: 12px 24px;
      border: 1px solid #D4D4D4;
      border-radius: 6px;
      margin-top: 6px;
      background: #F3F4F6;
    }
  }
  .explain-section {
    margin-bottom: 80px;
    .title {
      font-size: 36px;
      font-weight: 500;
      line-height: 110%;
      color: #0A0A0A;
      margin-bottom: 32px;
    }
  }
  .explain-list {
    width: 50%;
    li {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #E5E5E5;
      img {
        width: 20px;
        margin-right: 58px;
      }
      p {
        font-size: 16px;
        line-height: 130%;
        color: #404040;
      }
    }
  }
  .explain-list-en {
    width: 100%;
  }
}
@media screen and (max-width: 850px) {
  .course {
    padding-top: 24px;
    .banner {
      position: relative;
      margin-bottom: 51px;
      img {
        width: 100%;
      }
      .banner_content {
        h2 {
          font-size: 22px;
          line-height: 120%;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          line-height: 130%;
        }
      }
    }
    .tab-box {
      flex-direction: column;
      align-items: flex-start;
      .tab-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 133%;
        padding: 9px 26px;
        width: auto;
      }
      .tab {
        flex: auto;
        width: 100%;
      }
    }
    .tab-content {
      margin-bottom: 48px;
      .title {
        font-size: 20px;
        span:last-child {
          display: block;
          margin-top: 8px;
          margin-left: 0px;
        }
      }
      video {
        width: 100%;
      }
      .tips{
        padding: 12px;
      }
    }
    .explain-section {
      margin-bottom: 64px;
      .title {
        font-size: 24px;
        line-height: 120%;
        margin-bottom: 16px;
      }
    }
    .explain-list {
      width: 100%;
      li {
        img {
          margin-right: 12px;
        }
      }
    }
  }
}
</style>